import React from 'react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { R300 } from '@atlaskit/theme/colors';
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
export const loadChoicesAsyncFn = (jiraFieldsSearchOptionFns, errorUtils, createAnalyticsEvent, showFlag) => {
  return formStore => {
    return (questionId, query) => {
      try {
        // Find the question and load the search choices.
        for (const questionStore of formStore.questions) {
          if (questionStore.id === questionId && questionStore.formQuestion.jiraField) {
            var _questionStore$issueF, _questionStore$issueF2, _questionStore$issueF3, _questionStore$issueF4;
            const searchOptions = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 ? void 0 : (_questionStore$issueF2 = _questionStore$issueF.schema) === null || _questionStore$issueF2 === void 0 ? void 0 : _questionStore$issueF2.custom) && jiraFieldsSearchOptionFns.custom[questionStore.issueFieldData.schema.custom] || ((_questionStore$issueF3 = questionStore.issueFieldData) === null || _questionStore$issueF3 === void 0 ? void 0 : (_questionStore$issueF4 = _questionStore$issueF3.schema) === null || _questionStore$issueF4 === void 0 ? void 0 : _questionStore$issueF4.system) && jiraFieldsSearchOptionFns.system[questionStore.issueFieldData.schema.system] || undefined;
            if (searchOptions !== undefined) {
              const {
                searchOptionsFn,
                onSearchError
              } = searchOptions;
              return searchOptionsFn(questionStore.formQuestion.jiraField, query, questionStore.issueFieldData, formStore).then(options => {
                var _questionStore$issueF5, _questionStore$issueF6, _questionStore$issueF7, _questionStore$issueF8, _questionStore$issueF9;
                questionStore.setChoices(options.map(option => ({
                  id: option.value,
                  label: option.label
                })));
                fireOperationalAnalytics(createAnalyticsEvent({}), `${ActionSubject.SEARCH_ASYNC_CHOICES} ${Action.FINISHED}`, {
                  schemaKey: (_questionStore$issueF5 = (_questionStore$issueF6 = questionStore.issueFieldData) === null || _questionStore$issueF6 === void 0 ? void 0 : (_questionStore$issueF7 = _questionStore$issueF6.schema) === null || _questionStore$issueF7 === void 0 ? void 0 : _questionStore$issueF7.system) !== null && _questionStore$issueF5 !== void 0 ? _questionStore$issueF5 : (_questionStore$issueF8 = questionStore.issueFieldData) === null || _questionStore$issueF8 === void 0 ? void 0 : (_questionStore$issueF9 = _questionStore$issueF8.schema) === null || _questionStore$issueF9 === void 0 ? void 0 : _questionStore$issueF9.custom
                });
                return options;
              }).catch(error => {
                var _questionStore$issueF10, _questionStore$issueF11, _questionStore$issueF12, _questionStore$issueF13, _questionStore$issueF14;
                errorUtils.reportError(error, {
                  id: ActionSubject.SEARCH_ASYNC_CHOICES,
                  attributes: {
                    schemaKey: (_questionStore$issueF10 = (_questionStore$issueF11 = questionStore.issueFieldData) === null || _questionStore$issueF11 === void 0 ? void 0 : (_questionStore$issueF12 = _questionStore$issueF11.schema) === null || _questionStore$issueF12 === void 0 ? void 0 : _questionStore$issueF12.system) !== null && _questionStore$issueF10 !== void 0 ? _questionStore$issueF10 : (_questionStore$issueF13 = questionStore.issueFieldData) === null || _questionStore$issueF13 === void 0 ? void 0 : (_questionStore$issueF14 = _questionStore$issueF13.schema) === null || _questionStore$issueF14 === void 0 ? void 0 : _questionStore$issueF14.custom
                  }
                });

                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                if (error.error) {
                  // assume ApiError
                  const flag = onSearchError === null || onSearchError === void 0 ? void 0 : onSearchError(error);
                  if (flag) {
                    showFlag({
                      title: flag.title,
                      description: flag.description,
                      icon: /*#__PURE__*/React.createElement(ErrorIcon, {
                        label: "Error",
                        primaryColor: `var(--ds-icon-danger, ${R300})`
                      }),
                      isAutoDismiss: true
                    });
                  }
                }
                return Promise.resolve([]);
              });
            }
          }
        }
        throw new Error('`questionId` not found while trying to load search choices.');
      } catch (error) {
        errorUtils.reportError(error, {
          id: ActionSubject.SEARCH_ASYNC_CHOICES
        });
        return Promise.resolve([]);
      }
    };
  };
};